module.exports = __webpack_public_path__ + "static/media/QRAnimation_Image.3bc8a664.png";